import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate, useLocation } from "react-router-dom";
import { Produto } from "../../components/Types";
import Header from "../../components/header";
import MenuLateral from "../../components/MenuLateral";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import BoxProductDevolution from "./boxProductDevolution";
import ChatFlutuant from "../../components/ChatFlutuant";
import HeaderMobile from "../../components/headerMobile";
import IconBack from "../../componentsStyled/icon/Iconback";
import { isBrowser, isMobile } from "react-device-detect";
import MiniStepper from "../../components/miniStepper";

interface ProductSelectedProps {
  className?: string;
  selectedId?: string;
  produtos?: Produto[];
  produtosSelecionados?: Produto[];
  onDataUpdate?: (data: any) => void;
  onSaveTipoReembolso?: (tipoReembolso: string) => void;
  produtoSelecionadoData?: any;
  orderId?: string;
  allowed_clique_retire?: string;
  delivery_date?: string;
  payment_method?: string;
}

const SelectedProducts: React.FC<ProductSelectedProps> = () => {
  const navigate = useNavigate();
  let { state } = useLocation();

  if (!state) {
    state = { delivery_date: null, propSelectedId: null, produtosSelecionados: null };
  }

  const { delivery_date, propSelectedId, produtosSelecionados } = state;

  const produtos: [] | any = produtosSelecionados || [];
  const pedidoID = propSelectedId || "";

  const [dadosSelecionados, setDadosSelecionados] = useState(state?.dadosSelecionados || {});
  const [produtoData, setProdutoData] = useState<any>({});
  const [OpenModalCheckInputs, setOpenModalCheckInputs] = useState<boolean>(false);

  const updateProdutoData = (productId, key, value, variant_value?) => {
    // console.log(productId, key, value, variant_value);
    setProdutoData((prevProdutoData) => ({
      ...prevProdutoData,
      [productId]: {
        ...prevProdutoData[productId],
        [variant_value]: {
          ...prevProdutoData[productId]?.[variant_value],
          [key]: value,
        },
      },
    }));
  };

  /** Validar se todos os campos obrigatórios foram preenchidos */
  const areAllFieldsFilled = () => {
    return produtos.every((produto) => {
      const data = produtoData[`${produto.product_id}-${produto.product_sold_id}`]?.[produto.variant_value] || {};
      const camposObrigatoriosPreenchidos = data.tipoReembolso && data.motivoDevolucao && data.quantidade && data.subDevolucao && data.obsDev !== "";
      const fotoOk = !data.photoRequire || data.fotoAdicionada;
      return camposObrigatoriosPreenchidos && fotoOk;
    });
  };

  /** Enviar para o próxima página */
  const handleConfirmar = () => {
    // console.log("produtoData:", produtoData);
    const check = areAllFieldsFilled();
    if (!check) {
      console.log("check fail");
      setOpenModalCheckInputs(true);
      return;
    }

    const dadosSelecionadosAtualizados = produtos.map((produto) => {
      const dadosProduto = produtoData[`${produto.product_id}-${produto.product_sold_id}`][produto.variant_value] || {};
      return {
        ...dadosSelecionados,
        ...produto,
        ...{ selectedProduct: dadosProduto },
      };
    });

    navigate("/data", {
      state: dadosSelecionadosAtualizados,
    });
  };

  useEffect(() => {
    if (!produtosSelecionados) {
      navigate("/");
    }
  }, [state]);

  const handleBack = () => {
    navigate("/order");
  };

  const settings = {
    dots: true,
    arrow: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // adaptiveHeight: true,
  };
  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="request" />
          <Box width={"100%"} ml={2}>
            <Box display={"flex"} alignItems={"center"}>
              <Button onClick={handleBack} sx={{ minWidth: 0 }}>
                <IconBack width={20} />
              </Button>
              <p style={{ fontSize: 20, fontWeight: 500 }}>Preencha as informações do(s) produto(s) selecionado(s)</p>
            </Box>
            <Box display={"flex"} width={"90%"} justifyContent={"right"}>
              <MiniStepper step={1} />
            </Box>

            <Box px={4}>
              <p>Produtos selecionados</p>
              <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} gap={2} mt={2}>
                {produtos.map((produto, i) => (
                  <BoxProductDevolution key={i} produto={produto} updateProdutoData={updateProdutoData} delivery_date={delivery_date} pedidoID={pedidoID} />
                ))}
              </Box>
            </Box>

            <Button
              onClick={handleConfirmar}
              disabled={!areAllFieldsFilled()}
              variant="contained"
              sx={{
                backgroundColor: "#221F20",
                color: "#fff",
                margin: "20px auto",
                display: "block",
                borderRadius: 100,
                width: 450,
                "&:hover": {
                  backgroundColor: "#727272",
                  color: "#ffffff",
                },
              }}>
              Confirmar
            </Button>

            <Dialog open={OpenModalCheckInputs} onClose={() => setOpenModalCheckInputs(false)}>
              <DialogTitle>Dados obrigatórios ausentes</DialogTitle>
              <DialogContent>
                <DialogContentText>Verifique se algum campo ou imagem obrigatória foi inserida corretamente.</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenModalCheckInputs(false)} autoFocus>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="request" />
        <Box ml={1} mr={1}>
          <Box display={"flex"} width={"100%"} justifyContent={"center"} mb={2}>
            <MiniStepper step={1} />
          </Box>
          <Button onClick={handleBack} startIcon={<IconBack width={20} />} style={{ color: "#000", fontSize: isMobile ? 12 : 16, textAlign: "left" }}>
            Preencha as informações do(s) produto(s) selecionado(s)
          </Button>
          <Box mb={5}>
            <Slider {...settings}>
              {produtos.map((produto, i) => (
                <BoxProductDevolution key={i} produto={produto} updateProdutoData={updateProdutoData} delivery_date={delivery_date} pedidoID={pedidoID} />
              ))}
            </Slider>
          </Box>

          <Button
            onClick={handleConfirmar}
            disabled={!areAllFieldsFilled()}
            variant="contained"
            sx={{
              backgroundColor: "#221F20",
              color: "#fff",
              margin: "20px auto",
              display: "block",
              borderRadius: 100,
              width: { xs: "95%", md: 450 },
              "&:hover": {
                backgroundColor: "#727272",
                color: "#ffffff",
              },
            }}>
            Confirmar
          </Button>

          <Dialog open={OpenModalCheckInputs} onClose={() => setOpenModalCheckInputs(false)}>
            <DialogTitle>Dados obrigatórios ausentes</DialogTitle>
            <DialogContent>
              <DialogContentText>Verifique se algum campo ou imagem obrigatória foi inserida corretamente.</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenModalCheckInputs(false)} autoFocus>
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
      {/* mobile */}

      <ChatFlutuant />
    </>
  );
};

export default SelectedProducts;
